(function (global) {
  'use strict';
  const compact = value => String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  function normalise(value) {
    return String(value || '').normalize('NFKD').toLowerCase().replace(/(\d+(?:\.\d+)?)\s*(mm|cm|kw|w|m)(?=\b|\d)/g, '$1$2').replace(/[^a-z0-9.]+/g, ' ').trim().replace(/\s+/g, ' ');
  }
  function tokens(value) {
    let text = String(value || '').replace(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)\s*mm/gi, '$& $1mm $2mm');
    if (/pipe|pex|pert|mlcp|eurocone/i.test(text)) text = text.replace(/\b(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)(?![\d.])/gi, '$& $1mm $2mm');
    return normalise(text).split(' ').filter(Boolean);
  }
  function numericMatch(term, values) {
    return values.includes(term) || /^\d+(?:\.\d+)?$/.test(term) && values.some(v => /^(\d+(?:\.\d+)?)(?:mm|cm|kw|w|m|m2)$/.exec(v)?.[1] === term);
  }
  function query(value, titleConstraint = false) {
    let q = String(value || '').trim().replace(/\bufh\b/gi, 'underfloor heating');
    if (/[:"()]/.test(q)) return q;
    const model = /^ad[ -]?(clip|rail|plate|dry|tray|cxps|chipboard|eps[ -]?400|slim[ -]?max|slim)$/i.exec(q);
    if (model) return 'AD-' + model[1].replace(/[ -]/g, '').toUpperCase().replace('EPS400', 'EPS 400').replace('SLIMMAX', 'SLIM MAX');
    const wattage = /\b(100|140|150|160|200)\s*w?\b/i.exec(q);
    if (wattage && !q.replace(wattage[0], '').trim().replace(/\b(electric|underfloor|heating|sticky|mat|mats|kit|kits)\b/gi, '').trim()) {
      q = q.replace(wattage[0], (titleConstraint ? 'title:' : '') + wattage[1] + 'w');
    }
    return q;
  }
  function productMatch(title, variants, raw) {
    const code = compact(raw);
    const exact = variants.find(v => v.sku && compact(v.sku) === code || v.barcode && compact(v.barcode) === code);
    if (exact) return {variant: exact, score: 10000, exact: true};
    if (/[:"()]/.test(raw)) return {variant: null, score: 0};
    const terms = tokens(raw).filter(t => /^\d+(?:\.\d+)?(?:mm|cm|kw|w|m|m2)?$/.test(t));
    if (!terms.length) return {variant: null, score: 0};
    const titleTokens = tokens(title);
    if (terms.every(t => numericMatch(t, titleTokens))) return {variant: null, score: 200};
    const variant = variants.find(v => terms.every(t => numericMatch(t, tokens(title + ' ' + v.title))));
    return variant ? {variant, score: 0} : null;
  }
  function contentRank(title, raw, titles = []) {
    const stop = new Set(['the','a','an','of','for','to','in','and','or','is','are','does','do','i','my','your','how','much','what']);
    const words = value => tokens(value).map(t => t.length > 3 ? t.replace(/s$/, '') : t).filter(t => !stop.has(t));
    const terms = [...new Set(words(raw))];
    const titleWords = words(title);
    const otherTitles = titles.map(words);
    return terms.reduce((score, term) => score + (titleWords.includes(term) ? 1 + Math.log(1 + titles.length / (1 + otherTitles.filter(w => w.includes(term)).length)) : 0), 0) + (normalise(title) === normalise(raw) ? 10 : 0);
  }
  const api = {compact, normalise, tokens, numericMatch, query, productMatch, contentRank};
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else global.UheatSearchQuery = api;
  if (typeof document === 'undefined') return;
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !new URL(form.action, location.origin).pathname.endsWith('/search')) return;
    const input = form.querySelector('[name="q"]');
    if (!input || !input.value.trim()) return;
    const original = input.value.trim();
    const contentOnly = form.querySelector('[name="type"]')?.value === 'page,article';
    const effective = query(original, !contentOnly);
    let label = form.querySelector('[name="uheat_q"]');
    if (!label) {label = document.createElement('input');label.type = 'hidden';label.name = 'uheat_q';form.append(label);}
    label.value = original;
    input.value = effective;
  }, true);
  document.addEventListener('DOMContentLoaded', () => {
    const url = new URL(location.href);
    const original = url.searchParams.get('uheat_q');
    if (!original) return;
    document.querySelectorAll('[data-uheat-query-label]').forEach(el => {el.textContent = original;});
    document.querySelectorAll('search-page-input-component input[name="q"], [data-uheat-results-input]').forEach(el => {el.value = original;});
    document.querySelectorAll('[data-uheat-results-tab]').forEach(el => {
      const target = new URL(el.href, location.origin);
      target.searchParams.set('q', query(original, el.dataset.uheatResultsTab === 'product'));
      target.searchParams.set('uheat_q', original);
      el.href = target.pathname + target.search;
    });
  });
})(typeof window === 'undefined' ? globalThis : window);
